/**
 * Scroll Animations Module
 * Handles scroll-triggered animations for various elements
 */

const ScrollAnimations = {
    
    /**
     * Initialize scroll animations
     */
    init() {
        this.bindEvents();
    },

    /**
     * Bind scroll events
     */
    bindEvents() {
        window.addEventListener('scroll', this.handleScroll.bind(this));
        // Run once on load in case element is already in view
        this.handleScroll();
    },

    /**
     * Handle scroll event
     */
    handleScroll() {
        this.checkKeynotesFadeIn();
    },

    /**
     * Check if keynotes section should fade in
     */
    checkKeynotesFadeIn() {
        const targetElement = document.querySelector('.speaking__keynotes#about');
        
        if (!targetElement) {
            return;
        }

        // Skip if already has fade-in class
        if (targetElement.classList.contains('fade-in')) {
            return;
        }

        // Get element position relative to viewport
        const elementRect = targetElement.getBoundingClientRect();
        const elementTop = elementRect.top;

        // Check if element is 150px from top of screen
        if (elementTop <= 150) {
            targetElement.classList.add('fade-in');
        }
    }
};

export default ScrollAnimations;